// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Corporate_mainContainer__RmPRI","contBottom3":"Corporate_contBottom3__2sUcD","servIcon":"Corporate_servIcon__1bpdY"};